<template>
    <!-- <AlertBox v-if="$page.props.flash.success || $page.props.flash.error" :message="$page.props.flash.success || $page.props.flash.error" :type="$page.props.flash.error ? 'error' : 'success'" /> -->
    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900 pb-36">
       <div class="sm:mx-auto sm:w-full sm:max-w-screen-lg">
           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="text-3xl font-bold tracking-tight">
                       Choose a plan that‘s right for your team
                   </div>
                   <div class="text-center text-gray-800">
                       Pay by month or the year, and cancel at any time.
                   </div>
                   <div class="flex items-center justify-center w-full">
                       <div class="flex flex-col items-start justify-center w-full bg-white rounded-2xl overflow-scroll">
                           <div class="grid grid-cols-4 md:w-full w-[55rem] p-12 gap-y-12">
                               <div class="pr-8">
                                    <div class="text-lg font-light">Pricing</div>
                                    <div class="w-full mt-3 text-sm font-medium grid grid-cols-2 border border-gray-400 divide-x divide-x-gray-400 rounded-md">
                                        <div @click="showYearly = false" :class="[showYearly ? '' : 'bg-regal-blue-900 text-white','cursor-pointer rounded-l-md text-center p-2']">Monthly</div>
                                        <div @click="showYearly = true" :class="[showYearly ? 'bg-regal-blue-900 text-white' : '','cursor-pointer rounded-r-md text-center p-2']">Yearly</div>
                                    </div>
                                    <div class="text-xs text-gray-700 mt-1.5">Get two months <span class="font-bold">free</span> when you pay yearly.</div>
                               </div>
                               <div class="" v-for="(plan, index) in pricing">
                                   <div class="font-serif text-2xl mb-1.5 ">
                                       {{ plan.label }}
                                   </div>
                                   <div class="mb-1.5">
                                       <span>$</span>
                                       <div v-if="showYearly" class="inline">
                                            <span class="text-3xl font-bold tracking-tight">{{ plan.yearlyPrice / 100 }}</span>
                                           <span>/ year</span>
                                       </div>
                                       <div v-else class="inline">
                                            <span class="text-3xl font-bold tracking-tight">{{ plan.monthlyPrice / 100 }}</span>
                                           <span>/ month</span>
                                       </div>
                                       <div v-if="account" class="mt-10 pr-8">
                                            <div v-if="account.plan.name == plan.label && showYearly && account.billingPeriod == 'yearly' || account.plan.name == plan.label && !showYearly && account.billingPeriod == 'monthly'" >
                                                <Link :href="route('accounts.managePlan', { account: account.uuid, plan: account.plan.id, update: true })" as="button" method="post">
                                                    <Button label="Current plan" type="secondary" icon="CheckIcon" />
                                                </Link>
                                            </div>
                                          <form v-else-if="!account.plan.name || account.plan.name == 'Trial' || account.plan.id == 3 && !account.billingPeriod" @submit.prevent="submit(plan)" method="POST">
                                            <input type="hidden" name="lookup_key" :value="showYearly ? index + 3 : index" />
                                            <button type="submit" class="w-full bg-regal-blue-700 hover:bg-regal-blue-800 text-white font-medium text-center rounded-full py-3">Get Started</button>
                                            </form>
                                            <div v-else>
                                                <Link :href="route('accounts.managePlan', { account: account.uuid, plan: account.plan.id, update: true })" as="button" method="post">
                                                    <Button label="Get Started" />
                                                </Link>
                                            </div>
                                       </div>
                                       <div v-else class="pr-8 mt-10">
                                            <Link :href="route('signup')" as="button" class="w-full bg-regal-blue-700 hover:bg-regal-blue-800 text-white font-medium text-center rounded-full py-3">Free trial</Link>
                                       </div>
                                   </div>
                               </div>

                               <div class="text-sm">
                                   Listeners
                               </div>
                               <div class="text-sm">
                                   Up to 50
                               </div>
                               <div class="text-sm">
                                   Up to 500
                               </div>
                               <div class="text-sm">
                                   Up to 5,000 • <a class="text-regal-blue-700 text-xs underline hover:no-underline" href="mailto:hello@pager.fm?subject=Pager Enterprise Plans&body=Howdy, how much is it to have about _______ users on Pager?">More users?</a>
                               </div>

                               <div class="text-sm">
                                   Creator accounts
                               </div>
                               <div class="text-sm">
                                   1
                               </div>
                               <div class="text-sm">
                                   5
                               </div>
                               <div class="text-sm">
                                   10
                               </div>

                               <div class="text-sm">
                                   Episodes
                               </div>
                               <div class="text-sm">
                                   4/month
                               </div>
                               <div class="text-sm">
                                   20/month
                               </div>
                               <div class="text-sm">
                                   Unlimited
                               </div>

                               <div class="text-sm">
                                   Analytics
                               </div>
                               <div class="text-sm">
                                   Basic
                               </div>
                               <div class="text-sm">
                                   Advanced
                               </div>
                               <div class="text-sm">
                                   Advanced
                               </div>

                               <div class="text-sm">
                                   Creation tools
                               </div>
                               <div class="text-sm">
                               </div>
                               <div class="text-sm">
                                   <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                               </div>
                               <div class="text-sm">
                                   <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                               </div>

<!--                                <div class="text-sm">
                                   Private RSS Feeds
                               </div>
                               <div class="text-sm">
                               </div>
                               <div class="text-sm">
                                   <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                               </div>
                               <div class="text-sm">
                                   <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                               </div> -->

                               <div class="text-sm">
                                   Scheduled publishing
                               </div>
                               <div class="text-sm">
                               </div>
                               <div class="text-sm">
                                   <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                               </div>
                               <div class="text-sm">
                                   <svg class="w-6 h-6 text-regal-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                               </div>

                               <div class="text-sm">
                                   Data residency
                               </div>
                               <div class="text-sm">
                                   EU, Frankfurt
                               </div>
                               <div class="text-sm">
                                   EU, Frankfurt
                               </div>
                               <div class="text-sm">
                                   EU, Frankfurt
                               </div>

                               <div class="text-sm">
                                   Data encryption
                               </div>
                               <div class="text-sm">
                                   At rest &amp; in transit
                               </div>
                               <div class="text-sm">
                                   At rest &amp; in transit
                               </div>
                               <div class="text-sm">
                                   At rest &amp; in transit
                               </div>

                               <div class="text-sm">
                                   Support
                               </div>
                               <div class="text-sm">
                                   Email
                               </div>
                               <div class="text-sm">
                                   Email
                               </div>
                               <div class="text-sm">
                                   Designated team
                               </div>

                           </div>
                       </div>
                   </div>
               </div>
           </div>

       </div>
   </div>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import Button from '@/Shared/Button'
    import { ref } from 'vue'
    import { Inertia } from '@inertiajs/inertia'

    export default {
        setup(props) {
            const showYearly = props?.account?.billingPeriod && props?.account?.billingPeriod == 'yearly' ? ref(true) : ref(false)


            const submit = (plan) => {
                let lookupKey = null
                if (showYearly.value) {
                    lookupKey = plan.lookupKeyYearly
                } else {
                    lookupKey = plan.lookupKeyMonthly
                }
                Inertia.post(route('accounts.createCheckoutSession', props.account.uuid), {lookup_key: lookupKey})
            }

            return { showYearly, submit }
        },
        components: { Button },
        props: {
            account: Object,
            pricing: Object,
        },
    }
</script>
